var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A0A4A9",
  fillRule: "evenodd",
  d: "M5.75 14.5v6.25h12.5V14.5h1.25v6.25c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V14.5zm8.125 0L12 17l-1.875-2.5zm0-12.5c.166 0 .325.066.442.183l5 5a.63.63 0 0 1 .183.442V12h-1.25V8.25H14.5c-.69 0-1.25-.56-1.25-1.25V3.25h-7.5V12H4.5V3.25C4.5 2.56 5.06 2 5.75 2zM12 9.5l1.875 2.5h-3.75zm2.5-5.366V7h2.866z"
})));
export { SvgDocument as ReactComponent };
export default __webpack_public_path__ + "static/media/document.29dd0d49.svg";